module.exports = __webpack_public_path__ + "static/media/WXRWYR6.0cbb57c6.png";